<template>
  <div class="user-bar">
    <el-drawer
      :visible.sync="visi"
      :with-header="false"
      direction="rtl"
      size="12rem">
      <div class="list">
        <a class="item" @click="$refs.message.show()">
          <i class="el-icon-message" />查看消息
        </a>
        <el-popover
          placement="left-start"
          trigger="click"
          popper-class="lang-popper"
          ref="langPopover">
          <div class="lang-options">
            <a @click="changeLang('zh-cn')">中文</a>
            <a @click="changeLang('en-us')">English</a>
          </div>
          <a class="item" slot="reference"><svg-icon icon-class="language" />选择语言</a>
        </el-popover>
        <a class="item"><svg-icon icon-class="menu" />常用菜单</a>
        <a 
          class="item" 
          href="https://wpa1.qq.com/dYb6BIFr?_type=wpa&qidian=true"
          target="_blank">
          <i class="el-icon-headset" />
          联系客服
        </a>
      </div>
      <a 
        class="logout"
        @click="logoutHandle()">
        <i class="el-icon-switch-button" />
        退出登录
      </a>
    </el-drawer>
    <Message ref="message" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Message from './Message'
export default {
  props: {
    value: Boolean
  },
  computed: {
    visi: {
      get(){
        return this.value;
      },
      set(val){
        this.$emit('input', val);
      }
    }
  },
  components: {
    Message
  },
  methods: {
    ...mapActions(['LogOut']),
    logoutHandle(){
      this.$confirm('确定退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.LogOut();
        this.$message({
          message: '您已登出账户',
          type: 'success',
          duration: 1500
        });
        this.$nextTick(() => this.$router.push('/login'));
      }).catch()
    },
    changeLang(lang){
      console.log(lang);
      this.$message.info('抱歉，语言切换暂不支持。');
      console.log(this.$refs.langPopover);
      this.$refs.langPopover &&
      this.$refs.langPopover.doClose();
    }
  }
}
</script>

<style lang="scss" scoped>
>>> .el-drawer__body{
  display: flex;
  flex-direction: column;
  padding: 1.05rem 0;

  .list{
    flex: 1;
    display: flex;
    flex-direction: column;

    .item{
      display: flex;
      align-items: center;
      font-size: 1.19rem;
      padding-left: 1.4rem;
      height: 3.15rem;
      -webkit-tap-highlight-color: transparent;
      -moz-tap-highlight-color: transparent;

      .svg-icon,
      i{
        display: block;
        width: 1.4rem;
        font-size: 1.4rem;
        margin-right: 0.875rem;
        overflow: hidden;
      }
    }
  }

  .logout{
    display: flex;
    justify-content: center;
    align-items: center;
    border: 0.0175rem solid #eee;
    width: 80%;
    margin: 0 auto;
    font-size: 1.19rem;
    padding: .7rem 0;

    i{
      font-size: 1.4rem;
      margin-right: 0.35rem;
    }
  }
}
</style>
<style lang="scss">
.lang-popper{
  width: 5.25rem;
  min-width: initial;
  .lang-options{
    display: flex;
    flex-direction: column;
    a{
      padding: 0.2625rem 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/User/index.vue